import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

// analytics
Vue.use(VueAnalytics, {
  id: 'UA-44722268-1', // UA-44722268-1
  router,
});
